import { useState, useEffect } from 'react';

// Hook para detectar si la pantalla es pequeña
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const documentChangeHandler = () => setMatches(mediaQueryList.matches);

    mediaQueryList.addListener(documentChangeHandler);
    return () => {
      mediaQueryList.removeListener(documentChangeHandler);
    };
  }, [query]);

  return matches;
};

// Hook para detectar si el dispositivo es un móvil
const useMobileDevice = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    setIsMobile(isAndroid || isIOS);
  }, []);

  return isMobile;
};

// Hook principal que combina ambas funcionalidades
const useResponsiveDetection = (customMedia) => {
  const isCustomMedia = useMediaQuery(customMedia);
  const isSmallScreen = useMediaQuery('(max-width: 767px)');
  const isMobileDevice = useMobileDevice();

  return {
    isCustomMedia,
    isSmallScreen,
    isMobileDevice,
  };
};

export default useResponsiveDetection;
